import React, { lazy } from 'react';
import { styled } from '@mui/system';
import { useSelector } from 'react-redux';
import VideoPlaceholder from './VideoPlaceholder';
const ProgressiveVideo = lazy(() => import('./ProgressiveVideo'));

const ContentWrapper = styled('section')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    height: 635
  }
}));

const EmbedContainer = styled('div')(() => ({
  pointerEvents: 'none',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  '& video': {
    filter: 'brightness(0.3)',
    objectFit: 'fill'
  }
}));

const RenderVideo = ({ children }) => {
  const [wrapperHeight, setWrapperWidth] = React.useState(0);
  const isMobile = useSelector((state) => state.app.isMobile);
  const wrapper = React.useRef({ current: null });

  React.useEffect(() => {
    setWrapperWidth(window.innerHeight);
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setWrapperWidth(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ContentWrapper
      sx={{
        height: `${wrapperHeight}px`
      }}>
      {children}
      {isMobile ? (
        <VideoPlaceholder />
      ) : (
        <EmbedContainer ref={wrapper} tabIndex={-1}>
          <ProgressiveVideo
            type="video/mp4"
            dimensions={{
              width: '100%',
              height: `${wrapperHeight}px`
            }}
          />
        </EmbedContainer>
      )}
    </ContentWrapper>
  );
};

export default RenderVideo;
